import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CdHeader, CdFooter, CdMobileNav } from '@frontend/chatdigest-ui';

@Component({
  imports: [RouterModule, CdHeader, CdFooter, CdMobileNav],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  mobileNavOpen = false;
}
